/**密码校验的类型 */
export const RULE_MAP = [
  /**必须包含数字 */
  { rule: 'containNumber', name: 1, fun: checkContainNumber, i18ns: 'CONTAIN_NUMBER' },
  /**必须包含字母 */
  { rule: 'containsLetters', name: 2, fun: checkContainsLetters, i18ns: 'CONTAINS_LETTERS' },
  /**必须包含特殊字符 */
  { rule: 'containSpecialCharacters', name: 4, fun: checkContainSpecialCharacters, i18ns: 'CONTAIN_SPECIAL_CHARACTERS' },
  /**必须包含大写字母 */
  { rule: 'containCaptionLetter', name: 8, fun: checkContainCaptionLetter, i18ns: 'CONTAIN_CAPTION_LETTER' },
  /**必须包含小写字母 */
  { rule: 'containsLowercaseLetters', name: 16, fun: checkContainsLowercaseLetters, i18ns: 'CONTAINS_LOWERCASE_LETTERS' },
  /**密码不能有空格存在 */
  { rule: 'containsSpace', name: 32, fun: checkContainsSpace, i18ns: 'CONTAINS_SPACE' },
  /**密码必须6位以上 */
  { rule: 'charactersNumber', name: 64, fun: checkCharactersNumber, i18ns: 'CHARACTERS_NUMBER' },
  /**密码必须8位以上 */
  { rule: 'charactersRestrictions', name: 128, fun: checkCharactersRestrictions, i18ns: 'CHARACTERS_RESTRICTIONS' },
  /**密码里不能包含帐号 */
  { rule: 'containsAccountNumber', name: 256, fun: checkContainsAccountNumber, i18ns: 'CONTAINS_ACCOUNT_NUMBER' },
  /**禁止使用账号作为密码 */
  { rule: 'accountNumber', name: 512, fun: checkAccountNumber, i18ns: 'ACCOUNT_NUMBER' },
  /**同一字符出现的次数不能超过3次 */
  { rule: 'repetitions', name: 1024, fun: checkRepetitions, i18ns: 'REPETITIONS' },
  /**不能出现连续4位递增、递减或者键盘相邻的数字和字母 */
  { rule: 'continuousCharacters', name: 2048, fun: checkContinuousCharacters, i18ns: 'CONTINUOUS_CHARACTERS' }
]
/**必须包含数字 */
function checkContainNumber(value) {
  let reg1 = /^(?=.*\d)/
  return reg1.test(value)
}
/**必须包含字母 */
function checkContainsLetters(value) {
  let reg2 = /^(?=.*[a-zA-Z])/
  return reg2.test(value)
}
/**必须包含特殊字符 */
function checkContainSpecialCharacters(value) {
  // eslint-disable-next-line no-useless-escape
  let reg3 = /^(?=.*[~!@#$%^&*()_+`\-={}:";'<>?,.\/])/
  return reg3.test(value)
}
/**必须包含大写字母 */
function checkContainCaptionLetter(value) {
  let reg4 = /^(?=.*[A-Z])/
  return reg4.test(value)
}
/**必须包含小写字母 */
function checkContainsLowercaseLetters(value) {
  let reg5 = /^(?=.*[a-z])/
  return reg5.test(value)
}
/**密码不能有空格存在 */
function checkContainsSpace(value) {
  let reg6 = /^(?=^\S*$)/
  return reg6.test(value)
}
/**密码必须6位以上 */
function checkCharactersNumber(value) {
  return value.length > 6
}
/**密码必须10位以上字符 */
function checkCharactersRestrictions(value) {
  return value.length > 8
}
/**密码里不能包含帐号 */
function checkContainsAccountNumber(value, name) {
  return value.indexOf(name) === -1
}
/**禁止使用账号作为密码 */
function checkAccountNumber(value, name) {
  return value !== name
}
/**同一字符出现的次数不能超过3次 */
function checkRepetitions(value) {
  let arr = []
  for (let i = 0; i < value.length; i++) {
    arr.push(value[i])
  }
  let obj = arr.reduce((p, n) => (
    // eslint-disable-next-line no-sequences
    p[n]++ || (p[n] = 1),
    (p.max = p.max >= p[n] ? p.max : p[n]),
    (p.key = p.max > p[n] ? p.key : n), p), {})
  return obj.max <= 3
}
/**不能出现连续4位递增、递减或者键盘相邻的数字和字母 */
function checkContinuousCharacters(value) {
  const arr = [ 'qwertyuiop', 'poiuytrewq', 'asdfghjkl', 'lkjhgfdsa', 'zxcvbnm', 'mnbvcxz' ]
  if (value.length < 4) {
    return true
  }
  let isRight = true
  for (let j = 0; j < value.length - 3; j++) {
    //通过ASCII码判断正反序
    if (value.charCodeAt(j) === value.charCodeAt(j + 1) - 1 &&
      value.charCodeAt(j + 1) === value.charCodeAt(j + 2) - 1 &&
      value.charCodeAt(j + 2) === value.charCodeAt(j + 3) - 1 &&
      checkAscii(value[j]) && checkAscii(value[j + 1]) && checkAscii(value[j + 2]) && checkAscii(value[j + 3])
    ) isRight = false
    else if (value.charCodeAt(j) === value.charCodeAt(j + 1) + 1 &&
      value.charCodeAt(j + 1) === value.charCodeAt(j + 2) + 1 &&
      value.charCodeAt(j + 2) === value.charCodeAt(j + 3) + 1 &&
      checkAscii(value[j]) && checkAscii(value[j + 1]) && checkAscii(value[j + 2]) && checkAscii(value[j + 3])
    ) isRight = false
    //截取字段
    const str = value.slice(j, j + 4)
    for (let e in arr) {
      let fine = isRight
      if (arr[e].indexOf(str) !== -1) fine = false
      isRight = fine
    }
  }
  return isRight
}

//ASCII码区间判断
function checkAscii(value) {
  let num = value.charCodeAt(0)
  let ruleNum = num <= 57 && num >= 48
  let ruleLow = num <= 122 && num >= 97
  let ruleHigh = num <= 90 && num >= 65
  return ruleNum || ruleLow || ruleHigh
}